import React, { useState, useEffect } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './personInfo.css';
import loading from '../../img/loading.gif';
import print from '../../img/print.png'
import edit from '../../img/edit.png'
import trash from '../../img/trash.png'
import maps from '../../img/maps.png'
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { Buffer } from 'buffer'
import { createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed, 
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed, 
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed, 
    createBS,
    showError} from '../ViewCreator';


const cookies = new Cookies();
function BSInfo() {

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };


    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }


        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendBS(id);
    }, []);

    const setViews = (inner) => {
        var a = document.getElementById("viewFull");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            a.appendChild(inner[index])
        }
    }

    const sendBS = (id) => {
        var path = ip + '/api/bs/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    Swal.fire({
                        title: result.msg,
                        icon: "error",
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                    })

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    var pe = createBS(pers)
                    zz.push(pe)

                   
                    if (pers.persons.length > 0) {
                        var adr = document.createElement('div');
                        adr.innerHTML = "<br><hr>Зв'язки:";
                        zz.push(adr)
                        for (let index = 0; index < pers.persons.length; index++) {
                            var a = createPersonCollapsed(pers.persons[index].obj, index, pers.persons[index].type, pers.persons[index].text, "Р", "З");
                            var i = pers.persons[index].obj.id
                            const dblcl = i => () => {
                                sendPersonFullScreen(i)
                            }
                            a.ondblclick = dblcl(pers.persons[index].obj.id)
                            zz.push(a)

                        }
                    }

                   


                    
                    setViews(zz)

                    if (pers.persons.length > 0) {
                        for (let index = 0; index < pers.persons.length; index++) {
                            if (pers.persons[index].obj.image != undefined) {
                                getAvatar(pers.persons[index].obj.image, 'prevImageSearch')
                            }
                        }
                    }

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }

    const sendAddressFullScreen = (id) => {
        window.open("/address?id="+id)
      }
      const sendAutoFullScreen = (id) => {
        window.open("/auto?id="+id)
      }
      const  sendCompanyFullScreen = (id) => {
        window.open("/company?id="+id)
      }
      const  sendContactFullScreen = (id) => {
        window.open("/contact?id="+id)
      }
      const  sendOPMFullScreen = (id) => {
        window.open("/opm?id="+id)
      }
      const  sendDocFullScreen = (id) => {
        window.open("/document?id="+id)
      }
      const  sendGunFullScreen = (id) => {
        window.open("/gun?id="+id)
      }
      
      const sendKanFullScreen = (id) => {
        window.open("/kan?id="+id)
      }

    

    const getAvatar = async (id) => {
        var path = ip + '/files/avatar';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    Swal.fire({
                        title: result.msg,
                        icon: "error",
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                    })

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                    a.src = 'data:image/png;base64,' + result.data
                    a.className = 'prevImageSearch'
                }
            })

    }

    const getFile = async(id, fileName) => {
        var path = ip+'/files/file';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    Swal.fire({
                        title: result.msg,
                        icon: "error",
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                    })

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);

                    var byteArray = Buffer.from(result.data, "base64"); 
        
                    const blob = new Blob([byteArray],{ type: 'application/octet-binary' });
                    
                                        const link = document.createElement('a');
                                        // Browsers that support HTML5 download attribute
                                        if (link.download !== undefined) {
                                          const url = URL.createObjectURL(blob);
                                          link.setAttribute('href', url);
                                          link.setAttribute('download', fileName);
                                          link.style.visibility = 'hidden';
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }
                }
            })
      }

    const printSubmit = () => {

    }

    const mapsSubmit = () => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id");
        window.open("/maps?id=" + id + "&type=0", "_self");
    }

    const editSubmit = () => {
               const queryParams = new URLSearchParams(window.location.search)
               const id = queryParams.get("id");
               window.open("/edit/bs?id="+id, "_self")
           }
       
           const trashSubmit = () => {
               Swal.fire({
                   title: 'Ви дійсно бажаєте видалити запис',
                   //text: "Оновити інформацію?",
                   icon: 'question',
                   html:
                       '',
                   showDenyButton: false,
                   showCancelButton: true,
                   confirmButtonText: 'Видалити',
                   denyButtonText: 'Оновити',
       
                   background: '#2B2B2B',
                   color: '#FFF'
               }).then((result) => {
                   if (result.isConfirmed) {
                       removePerson()
                   }
               })
           }
       
           const removePerson = () => {
               const queryParams = new URLSearchParams(window.location.search)
               const id = queryParams.get("id");
               var path = ip + '/api/bs/remove';
               var bd = encryptAes((id))
               const requestOptions = {
                 headers: {
                   'Content-Type': 'Content-type: text/html'
                 },
                 credentials: 'include',
                 uri: path,
                 encoding: 'latin1',
                 body: bd,
                 method: 'POST'
               };
               fetch(path, requestOptions)
                 .then()
                 .then(response => { return response.arrayBuffer() })
                 .then((buffer) => {
                   const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                   const text = decoder.decode(buffer);
                   try {
                     var result = JSON.parse(text);
                     showError(result.msg)
           
                   } catch (error) {
                     const decryptedText = decryptAes(text);
                     var result = JSON.parse(decryptedText);
                     storeKey('test_data', result.key);
                     Swal.fire({title: 'Видалено', text: '', icon: 'success', timer: 5000 ,background: '#2B2B2B',
                       color: '#FFF',
                       didClose: (toast) => {
                         window.open("/main","_self")
                       }})
                     
                   }
                 })
             }

    return (
        <div className="main">
            <div className="header">
                <img src={logo} className="logo" alt="logo" />
                <div className="title" onClick={mainSubmit}>SPACE</div>
                <div className="subtitle">(info) </div>
                <button className="headerButton" onClick={mapsSubmit} >
                    <img src={maps} className="headerImage" />
                </button>
                <button className="headerButton" onClick={printSubmit} >
                    <img src={print} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 2} onClick={editSubmit} >
                    <img src={edit} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 1} onClick={trashSubmit} >
                    <img src={trash} className="headerImage" />
                </button>

            </div>


            <div id="viewFull">

            </div>
        </div>
    );
}


export default BSInfo;